export const TileBackgroundColor = {
  MONO_100: 'mono_100',
  MONO_200: 'mono_200',
  MONO_900: 'mono_900'
};